import { AbstractControl, ValidatorFn } from '@angular/forms';
export interface Data {
  ruleId: string;
  ruleType: string;
  merchantId?: string;
}
export function validatePercent(field?: string): ValidatorFn {
  return (input: AbstractControl<number>) => {
    if (input.value === 0) {
      return { error: true };
    }

    const allowedDecimalPlaces = field === 'percentageOfAmount' ? 4 : 2;

    if (Number.isInteger(input.value)) {
      return null;
    } else if (
      input &&
      input.value &&
      input.value.toString().split('.').length >= 2
    ) {
      const val = input.value.toString().split('.')[1];
      if (val && val?.length > allowedDecimalPlaces) {
        return {
          error: `up to ${allowedDecimalPlaces} decimal places are allowed`
        };
      }
    }
    return null;
  };
}

export const validatePoints: ValidatorFn = (control: AbstractControl) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const rawValue = control.value;
  if (rawValue == null || rawValue === '') return null;
  const num = Number(rawValue);
  if (!Number.isInteger(num) || num < 0) {
    return { error: 'decimal places not allowed' };
  }
  return null;
};

// for test value of x
export const validateFactors: ValidatorFn = (
  value: AbstractControl<number>
) => {
  if (value.value == null) return null;
  if (
    (value.value && parseInt(value.value.toFixed()) !== value.value) ||
    value.value < 1
  ) {
    return { error: 'Enter an integer more than 1' };
  }
  return null;
};

export function preventNonNumericalInput(event: KeyboardEvent) {
  const specialKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    '.'
  ];

  // If it's a special key, allow it
  if (specialKeys.includes(event.key)) {
    return;
  }

  // If the key isn't a number, prevent it
  if (!/^\d$/.test(event.key)) {
    event.preventDefault();
  }
}

export function stripLeadingZeros(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.value) {
    const stripped = input.value.replace(/^0+/, '') || '0';
    if (stripped !== input.value) {
      input.value = stripped;
      input.dispatchEvent(new Event('input'));
    }
  }
}

export const pastDateValidator: ValidatorFn = (control: AbstractControl) => {
  if (!control.value) return null;
  const date = new Date(control.value as string);
  if (isNaN(date.getTime())) return null;
  const now = new Date();
  now.setSeconds(0, 0);
  date.setSeconds(0, 0);
  return date < now
    ? { matDatetimePickerMin: { min: now, actual: date } }
    : null;
};

export const validateYear: ValidatorFn = (value: AbstractControl<string>) => {
  const isValid =
    parseInt(value.value) &&
    value.value.length === 4 &&
    parseInt(value.value) > 1900 &&
    parseInt(value.value) <= new Date().getFullYear();

  if (!isValid) {
    return { error: true };
  }
  return null;
};
